export default __webpack_public_path__ + "static/feature_02-8aa306eee506e7d0fc0cb677c66633d7.png";